import {
  Component,
  EventEmitter,
  Input,
  Output,
  inject
} from '@angular/core';
import {
  ContentListPageItem,
  ContentListSourceContainer
} from '../../core/definitions/object-content-tab/content-list-source-container';
import {SearchResultSelectionsService} from '../../object-search/search-result-selections.service';

@Component({
    selector: 'app-object-content-list-source-array-items',
    templateUrl: './object-content-list-source-array-items.component.html',
    styleUrls: ['./object-content-list-source-array-items.component.scss'],
    standalone: false
})
export class ObjectContentListSourceArrayItemsComponent {
  private readonly searchResultSelectionsService: SearchResultSelectionsService = inject(SearchResultSelectionsService);

  @Input() contentListSource: ContentListSourceContainer;
  @Input() triggerAnimation: boolean;
  @Input() hasOperationMenu: boolean;
  @Output() afterDeleted = new EventEmitter<boolean>();

  afterDelete() {
    this.afterDeleted.emit(true);
  }

  setSelected(event: MouseEvent, pageItem: ContentListPageItem) {
    this.searchResultSelectionsService.selectSearchResultItem(
      pageItem.listItem.object,
      this.contentListSource.searchContainer,
      event.shiftKey
    );
  }
}
